module.exports = __webpack_public_path__ + "static/img/chair-ai.6a8f44c3.png";